export default __webpack_public_path__ + "static/media/isg-logo.29750c79.png";